/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, lockedBy: NonNullable<unknown> }} Explorer_Info_Overwrite_Locked_ErrorInputs */

const en_explorer_info_overwrite_locked_error = /** @type {(inputs: Explorer_Info_Overwrite_Locked_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cannot overwrite "${i?.name}" as it's locked by ${i?.lockedBy}`)
};

const fr_explorer_info_overwrite_locked_error = /** @type {(inputs: Explorer_Info_Overwrite_Locked_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossible d'ecraser "${i?.name}" car il est verrouille par ${i?.lockedBy}`)
};

const de_explorer_info_overwrite_locked_error = /** @type {(inputs: Explorer_Info_Overwrite_Locked_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" kann nicht überschrieben werden, da es von ${i?.lockedBy} gesperrt ist.`)
};

const it_explorer_info_overwrite_locked_error = /** @type {(inputs: Explorer_Info_Overwrite_Locked_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile sovrascrivere "${i?.name}" perché è bloccato da ${i?.lockedBy}`)
};

const ru_explorer_info_overwrite_locked_error = /** @type {(inputs: Explorer_Info_Overwrite_Locked_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Невозможно перезаписать "${i?.name}", так как он заблокирован ${i?.lockedBy}`)
};

const es_explorer_info_overwrite_locked_error = /** @type {(inputs: Explorer_Info_Overwrite_Locked_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se puede sobrescribir "${i?.name}" ya que está bloqueado por ${i?.lockedBy}`)
};

const zh_cn2_explorer_info_overwrite_locked_error = /** @type {(inputs: Explorer_Info_Overwrite_Locked_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`无法覆盖“${i?.name}”，因为它已被“${i?.lockedBy}”锁定。`)
};

const ja_explorer_info_overwrite_locked_error = /** @type {(inputs: Explorer_Info_Overwrite_Locked_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」は${i?.lockedBy}によってロックされているため上書きできません`)
};

const hi_explorer_info_overwrite_locked_error = /** @type {(inputs: Explorer_Info_Overwrite_Locked_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" को ओवरराइट नहीं किया जा सकता क्योंकि यह ${i?.lockedBy} द्वारा लॉक किया गया है।`)
};

const pt_pt2_explorer_info_overwrite_locked_error = /** @type {(inputs: Explorer_Info_Overwrite_Locked_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não é possível sobrescrever "${i?.name}" porque está bloqueado por ${i?.lockedBy}`)
};

/**
* | output |
* | --- |
* | "Cannot overwrite \"{name}\" as it's locked by {lockedBy}" |
*
* @param {Explorer_Info_Overwrite_Locked_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_overwrite_locked_error = /** @type {((inputs: Explorer_Info_Overwrite_Locked_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Overwrite_Locked_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_overwrite_locked_error(inputs)
	if (locale === "de") return de_explorer_info_overwrite_locked_error(inputs)
	if (locale === "it") return it_explorer_info_overwrite_locked_error(inputs)
	if (locale === "ru") return ru_explorer_info_overwrite_locked_error(inputs)
	if (locale === "es") return es_explorer_info_overwrite_locked_error(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_overwrite_locked_error(inputs)
	if (locale === "ja") return ja_explorer_info_overwrite_locked_error(inputs)
	if (locale === "hi") return hi_explorer_info_overwrite_locked_error(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_overwrite_locked_error(inputs)
	return en_explorer_info_overwrite_locked_error(inputs)
});